<script lang="ts" setup>
import { type DateType } from '@/utilities/dateutils';

withDefaults(
    defineProps<{
        /**
         * The value to display
         * @default null
         */
        value: Date | null;

        /**
         * The format of the date
         * @default 'DATETIME'
         */
        format?: DateType;

        /**
         * If the text should be monospace
         * @default true
         */
        monospace?: boolean;

        /**
         * If the min value should be shown or not rendered at all
         */
        dontshowminvalue?: boolean;
    }>(),
    {
        value: null,
        format: 'DATETIME',
        monospace: true,
    },
);
</script>
<template>
    <span
        class="field-renderer-datetime text-nowrap"
        :class="{ 'font-monospace': monospace }"
        :type="format"
        v-if="!(dontshowminvalue && value?.getFullYear() == 1)"
    >
        {{ $td(value, format)?.replace(',', '.') }}
    </span>
</template>
